export async function subscribe_to_channel(channel, process, websocket_handler) {
    return new Promise(async (resolve, reject) => {
        var _a;
        await websocket_handler.wait();
        try {
            const subscriptionChannelName = process == "subscribe" ? "channel-subscribe" : "channel-presence";
            const { data } = await websocket_handler.pushForSecureLine(subscriptionChannelName, {
                "channel": channel
            }, true);
            if (data['status'] == 'not-OK') {
                reject(data['error']);
            }
            let { channelConfig: rawData, snapshot, presenceUsers, channel: channelName, channelNamespace, subscriptionID } = data;
            if (rawData) {
                const channelConfig = {
                    channelName: channelName,
                    channelNamespace: channelNamespace,
                    channelType: rawData.TypeofChannel,
                    snapshot: snapshot,
                    presenceUsers: presenceUsers,
                    subscriptionID: subscriptionID,
                    orchestratorEnabled: (_a = rawData.IsInterceptorEnabled) !== null && _a !== void 0 ? _a : false
                };
                resolve(channelConfig);
            }
        }
        catch (error) {
            reject(error);
        }
    });
}
export async function unsubscribe_from_channel(channel, subscriptionID, process, websocket_handler) {
    return new Promise(async (resolve, reject) => {
        await websocket_handler.wait();
        try {
            const subscriptionChannelName = process == "subscribe" ? "channel-unsubscribe" : "presence-unsubscribe";
            const { data } = await websocket_handler.pushForSecureLine(subscriptionChannelName, {
                "channel": channel,
                "subscriptionID": subscriptionID
            }, true);
            if (data['status'] == 'not-OK') {
                reject(data['error']);
            }
            resolve(true);
        }
        catch (error) {
            reject(error);
        }
    });
}
export async function get_interceptor_config(interceptor, websocket_handler) {
    return new Promise(async (resolve, reject) => {
        await websocket_handler.wait();
        try {
            const { data } = await websocket_handler.pushForSecureLine("interceptor-subscribe", { "interceptor": interceptor }, true);
            if (data['status'] == 'not-OK') {
                reject(data['error']);
            }
            let { interceptorConfig } = data;
            resolve(interceptorConfig);
        }
        catch (error) {
            reject(error);
        }
    });
}
